'use strict';

var _ = require('../dependency')._,
    config = require('../config'),
    $u = require('../utilities'),
    chartTypes = require('./chartTypes');

var GRAPHS = config.graphs,
    $d = config.druid;

var chartId = 'CUSTOMER_TREND',
    dataSeries = {
        TIMESTAMP: 'timestamp',
        CUSTOMERS: 'customers'
    },
    fieldNames = {
        CUSTOMERS: 'numOfCustomers'
    },
    /**
     * [dataConfig The query params to pass to the API http endpoint POST. Currently this are specific to druid querying.
     * can be modified for other data provider systems.]
     * @type {Object}
     */
    dataConfig = [{
        queryType: 'timeseries',
        /*!ToDo above use this from druid settings object (settings maybe in matrix charts)*/
        dataSource: 'babbageCustomer',
        /*above Can be set in library matrix charts*/
        aggregations: [{
            type: 'longSum',
            name: dataSeries.CUSTOMERS,
            fieldName: fieldNames.CUSTOMERS
        }]
    }];


module.exports = chartTypes.trendCharts.createConfig({
    chartId: chartId,
    dataSeries: dataSeries,
    fieldNames: fieldNames,
    dataConfig: dataConfig,
    chartTemplate: chartTemplate,
    averageTask: true
});

function chartTemplate(data, width) {
    width = parseInt(width.match(/\d+/g)[0], 10);
    var duration = data.__duration,
        granularity = data.__granularity,
        xAxisLabelOffset = $u.charts.getXaxisOffset(duration),
        x = xAxisLabelOffset.x,
        y = xAxisLabelOffset.y,
        legendAdjustments = $u.charts.getLegendAdjustments(duration, false, false);

    var yAxisBaseUnit = '';
    var yAxisRoundOff = false;
    var xAxisFormatter = $u.charts.generateXaxisDaysData;
    var yAxisFormatter = $u.charts.chartYaxisFormatter;
    var yAxisTrimDecimalPlaces = 2;

    var chartTemplateObj = {
        dataTableConfig: {
            granularity: granularity,
            duration: duration,
            xAxisFormatter: xAxisFormatter,
            yAxisFormatter: yAxisFormatter,
            yAxisBaseUnit: yAxisBaseUnit,
            yAxisRoundOff: yAxisRoundOff,
            xAxisDataHeader: 'Dates'
        },
        chart: {
            zoomType: 'x,y',
            marginTop: GRAPHS.GLOBAL.CHART_MARGINS.TOP,
            marginBottom: GRAPHS.GLOBAL.CHART_MARGINS.BOTTOM,
            events: {
                load: function() {
                    var dataUnit,
                        chartContext = this,
                        dataArray;

                    _.forEach(chartContext.yAxis, function(yAxisObject) {
                        dataArray = [];
                        dataUnit = ' ';
                        _.forEach(yAxisObject.series, function(seriesItem) {
                            dataArray.push(seriesItem.dataMax);
                        });
                        dataUnit = $u.charts.getUnitsFromMax(_.max(dataArray), '').unit;
                        yAxisObject.setTitle({
                            text: data.i18n.YAXIS_TEXT + ' ' + dataUnit
                        });
                    });
                }
            }
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function() {
                var currentContext = this;
                var tooltipUnitObj = yAxisFormatter(currentContext.y, currentContext.series.dataMax,
                    yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces);

                return $u.charts.sformat('{0}<br>{1}: <b>{2} {3}</b>',
                    xAxisFormatter(duration, granularity, currentContext.x),
                    currentContext.series.name,
                    tooltipUnitObj.value,
                    tooltipUnitObj.unit);

            },
            valueDecimals: 0
        },
        legend: {
            y: legendAdjustments.y,
            itemDistance: legendAdjustments.itemDistance
        },
        xAxis: {
            categories: data.timestamp,
            /*!ToDo this may be a setting for druid default time series name*/
            tickmarkPlacement: 'on',
            labels: {
                step: function() {
                    if (data.timestamp) {
                        return data.timestamp.length >=
                            GRAPHS.GLOBAL.MAX_XAXIS_LABELS ? 2 : 1;
                    }
                }(),
                rotation: -45,
                align: 'center',
                x: x,
                y: y,
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                },
                formatter: function() {
                    return xAxisFormatter(duration, granularity, this.value);
                },
                useHTML: true,
                autoTransform: true
            }
        },
        yAxis: [{
            allowDecimals: false,
            title: {
                text: '',
                style: {
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_TITLE,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                }
            },
            labels: {
                format: '{value}',
                //Set the formatting of the y axis labels(the tick labels) and set y axis title units too.
                formatter: function() {
                    var that = this,
                        yAxisValue = that.value,
                        yMaxValue = that.axis.dataMax;

                    return yAxisFormatter(yAxisValue, yMaxValue,
                        yAxisBaseUnit, yAxisRoundOff).value;
                },
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                x: -20
            },
            min: 0,
            maxPadding: 0.1,
            lineColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
            lineWidth: 1
        }],
        plotOptions: {
            line: {
                marker: {
                    enabled: true,
                    radius: width / 400 + 1
                }
            }
        },
        series: [{
            showInLegend: false,
            type: 'line',
            name: 'Customers',
            data: data.customers,
            color: GRAPHS.GLOBAL.COLORS.MOJO_BLUE,
        }]
    };
    chartTemplateObj = _.assign({}, config.defaultSettings, chartTemplateObj);
    return chartTemplateObj;
}
